import { blackColors, grayColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';


const PlanDetailStyle = () => ({


	subheader: {
		marginLeft: 8,
		display: 'flex',
		alignSelf: 'center',
	},
	planDetail: {
		backgroundColor: grayColor[16],
		borderRadius: '15px',
		padding: '2% 3% 2% 3%'
	},
	installationDetail: {
		backgroundColor: grayColor[16],
		borderRadius: '15px',
		padding: '3%',
		marginTop: '1%'
	},
	title: {
		fontSize: '28px',
		color: primaryColor[0],
		fontWeight: 500
	},
	subTitle: {
		fontSize: '20px',
		color: primaryColor[0],
		fontWeight: 500
	},
	contract: {
		color: grayColor[20],
		fontSize: '18px'
	},
	validity: {
		color: grayColor[23],
		fontSize: '10px'
	},
	editIcon: {
		margin: 0
	},
	description: {
		color: grayColor[24],
		display: 'flex',
		paddingTop: '3px',
		alignItems: 'baseline'
	},
	descriptionText: {
		margin: 0,
		paddingLeft: 5
	},
	addOnServices: {
		display: 'flex',
		paddingTop: '18px'
	},
	installationTitle: {
		display: 'flex',
		fontSize: '13px',
		lineHeight: 'normal',
		fontWeight: '500',
	},
	phoneIcon: {
		fontSize: '15px',
		alignSelf: 'center',
	},
	titleSection: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: '3px',
		alignItems: 'end',
		color: primaryColor[0]
	},
	horizontalLine: {
		border: '1px solid darkgrey'
	},
	summationHorizontalLine: {
		border: '1px solid black',
		marginTop: '4px',
		marginBottom: '10px'
	},
	flexAndJustifyContexnt: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	additionalServices: {
		marginTop: 4,
		paddingTop: 8,
		borderTop: `1px solid ${blackColors[4]}`,
	},
	additionalService: {
		display: 'flex',
	},
	serviceName: {
		flex: 1,
	},
	servicePrice: {
		flex: 1,
		textAlign: 'right',
	},
	summaryContainer: {
		display: 'flex',
	},
	summary: {
		flex: 1,
	},
	buttonsContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	flex: {
		display: 'flex',
	},
	flex1: {
		flex: 1,
	},
	alignEnd: {
		display: 'flex',
		alignItems: 'end',
	},
	alignRight: {
		textAlign: 'right',
	},
	servicesHeader: {
		marginBottom: 7,
	},
	monthlyCost: {
		paddingTop: 4,
		marginTop: 6,
		borderTop: `1px solid ${blackColors[4]}`,
	},

});

export default PlanDetailStyle;
